import imageUrlBuilder from '@sanity/image-url'
import PropTypes from 'prop-types'
import React from 'react'
import { withSiteData } from 'react-static'
import styled from 'styled-components'
import { Flex } from '../../styles/styled-common'
import Gallery from '../Gallery'

const StGallery = styled(Gallery)`
  a {
    max-width: 70%;
    margin-top: 4px;
    img {
      max-width: 100%;
    }
  }
  margin: 10px;
`

const StFlex = styled(Flex)`
  font-size: 0.9em;
  height: 100%;
`

class ControlPanelCell extends React.PureComponent {
  state = {}

  static propTypes = {
    screenshots: PropTypes.array,
    type: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      isLightboxOpen: false,
      type: props.type
        ? props.type === 'tcadmin'
          ? 'TCAdmin'
          : 'Custom'
        : 'Unknown',
    }

    this._builder = imageUrlBuilder(
      Object.assign({}, props.siteData.sanityConfig, {
        baseUrl: 'https://cdn.sanity.io',
      })
    )
  }

  _closeLightbox = () => {
    this.setState({
      isLightboxOpen: false,
      currentImage: 0,
    })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const Builder = imageUrlBuilder(
      Object.assign({}, nextProps.siteData.sanityConfig, {
        baseUrl: 'https://cdn.sanity.io',
      })
    )
    return {
      controlPanelScreenshots: (nextProps.screenshots || []).map(ss => ({
        src: Builder.image(ss).url(),
        thumbnail: Builder.image(ss)
          .width(105)
          .height(65)
          .url(),
        thumbnailWidth: 105,
        thumbnailHeight: 65,
        srcset: [240, 360, 500, 750, 900, 1080, 1300, 1600].map(
          w =>
            `${Builder.image(ss)
              .fit('max')
              .width(w)
              .url()} ${w}w`
        ),
        thumbnailCaption: ss.caption,
        caption: ss.caption,
      })),
    }
  }

  render() {
    const { screenshots, siteData, type, ...props } = this.props
    const sanityImages =
      screenshots &&
      screenshots.map(({ caption, ...ss }) => ({
        src: this._builder.image(ss).url(),
        thumbnail: this._builder.image(ss).url(),
        caption,
      }))

    return (
      <StFlex flexDirection="column" {...props}>
        {this.state.type}
        {sanityImages && sanityImages.length ? (
          <StGallery
            images={this.state.controlPanelScreenshots}
            previewCount={1}
            showCaption={false}
            justify="center"
          />
        ) : null}
      </StFlex>
    )
  }
}

export default withSiteData(ControlPanelCell)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/ControlPanelCell.jsx